module.exports = __webpack_public_path__ + "static/media/placement-not-found.3b782622.jpg";